import { useQuery } from "@tanstack/react-query";
import { GetListRequestParams, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductBadge } from "../../product.types";
import { requestProductBadges } from "./productBadges.request";

const useProductBadges = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<GetListResponse<ProductBadge>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["product-badges", "all", requestParams],
    queryFn: async () => await requestProductBadges(requestParams),
    ...options
  });

  return { badges: data?.data, meta: data?.meta, ...rest };
};

export default useProductBadges;
